<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina Titlu="Istoric emailuri" @on_add_clicked="show_dialog()" :AdaugaVisible="false" />
            </div>
          </template>
          <div class="filtre">
            <el-form @submit.prevent.native="refresh_info()">
              <el-row style="margin: 10px" class="input-group">
                <el-col class="input-element">
                  <el-form-item label='Tip email'>
                    <el-select class='full-width' v-model='Filters.TipEmail' filterable size="small">
                      <el-option label='Toate' value='-1' />
                      <el-option label='Programare noua' value='Nou' />
                      <el-option label='Amanare' value='Amanare' />
                      <el-option label='Anulare' value='Anulare' />
                      <el-option label='Depozitare' value='Depozitare' />
                      <el-option label='Resetare parola' value='Resetare parola' />
                      <el-option label='Altele' value='Altele' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Client / Utilizator">
                    <el-input v-model="Filters.NumeClientUtilizator" class="full-width" size="small" />
                  </el-form-item>
                </el-col>

                <el-col class="input-element">
                  <el-form-item label='Perioada'>
                    <br>
                    <el-date-picker v-model="Filters.Data" type="daterange" range-separator="-"
                      start-placeholder="Data inceput" end-placeholder="Data sfarsit"
                      :picker-options="datePickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col class="input-element">
                  <el-form-item label="Trimis">
                    <el-select v-model="Filters.Status" class="full-width" size="small">
                      <el-option label="Toate" value="-1"></el-option>
                      <el-option label="Trimise" value="1"></el-option>
                      <el-option label="Netrimise" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="ID Programare">
                    <el-input v-model="Filters.IdRezervare" class="full-width" size="small" placeholder="Ex: 1234" />
                  </el-form-item>
                </el-col>

                <el-col class="input-element">
                  <el-form-item label='Data Programare (Masina)'>
                    <br>
                    <el-date-picker v-model="Filters.DataRezervarii" type="daterange" range-separator="-"
                      start-placeholder="Start" end-placeholder="Sfarsit" :picker-options="datePickerOptions"
                      format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :md="24">
                  <el-button type="primary" native-type="submit" @click="refresh_info()">
                    Aplica
                  </el-button>
                  <el-button type="danger" native-type="submit" @click="reset()">
                    Reseteaza
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>


    <el-table :data="Results" style="width: 100%">
      <el-table-column prop="Id" label="#" />

      <el-table-column prop="IdRezervare" label="ID Prog.">
        <template slot-scope="scope">
          <span v-if="scope.row.IdRezervare > 0">#{{ scope.row.IdRezervare }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="Data Prog.">
        <template slot-scope="scope">
          <span v-if="scope.row.DataRezervarii">{{ scope.row.DataRezervarii | DataOraFaraSec }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="Client / Utilizator">
        <template slot-scope="scope">
          <span v-if="scope.row.NumeClient"> {{ scope.row.NumeClient }} </span>
          <span v-if="scope.row.NumeUtilizator"> {{ scope.row.NumeUtilizator }} </span>
        </template>
      </el-table-column>

      <el-table-column label="Telefon">
        <template slot-scope="scope">
          <div v-if="scope.row.TelefonClient">
            <a :href="'tel:' + scope.row.TelefonClient" style="text-decoration: none; color: inherit;">
              <i class="el-icon-phone" style="color: #409EFF"></i> {{ scope.row.TelefonClient }}
            </a>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="Destinatar" label="Destinatar">
        <template slot-scope="scope">
          <a :href="'mailto:' + scope.row.Destinatar" style="color: #409EFF; text-decoration: none;">
            {{ scope.row.Destinatar }}
          </a>
        </template>
      </el-table-column>

      <el-table-column label="Tip Email">
        <template slot-scope="scope">
          <span v-if="scope.row.TipEmail == 'Nou'">Programare noua</span>
          <span v-else>{{ scope.row.TipEmail }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Data Trimis">
        <template slot-scope="scope">
          {{ scope.row.Data | DataOraFaraSec }}
        </template>
      </el-table-column>

      <el-table-column label="Trimis">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.Status == 1" type="success" size="mini">Da</el-tag>
          <el-tag v-else type="danger" size="mini">Nu</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="Actiuni" width="100px" align="center">
        <template slot-scope="scope">
          <el-dropdown trigger="click" @command="handleActionCommand">
            <el-button type="primary" size="mini" plain icon="el-icon-more">
            </el-button>
            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item icon="el-icon-date" style="font-weight: bold; color: #409EFF"
                :disabled="!scope.row.IdRezervare || scope.row.IdRezervare <= 0"
                :command="{ action: 'open_programare', row: scope.row }">
                Deschide Programarea
              </el-dropdown-item>

              <el-dropdown-item icon="el-icon-view" :command="{ action: 'view', row: scope.row }">
                Vizualizare Email
              </el-dropdown-item>

              <el-dropdown-item icon="el-icon-close" style="color: #F56C6C"
                :disabled="!scope.row.IdRezervare || scope.row.StatusRezervare == 'Anulata' || scope.row.IdDeviz > 0"
                :command="{ action: 'cancel', row: scope.row }">
                Anuleaza Programarea
                <span v-if="scope.row.StatusRezervare == 'Anulata'">(Anulata)</span>
                <span v-else-if="scope.row.IdDeviz > 0">(Are deviz)</span>
              </el-dropdown-item>

              <el-dropdown-item icon="el-icon-edit" :command="{ action: 'correct_email', row: scope.row }"
                :disabled="!scope.row.IdRezervare">
                Corecteaza Email
              </el-dropdown-item>

              <el-dropdown-item icon="el-icon-refresh-right" divided :command="{ action: 'resend', row: scope.row }"
                :disabled="!scope.row.IdRezervare || scope.row.IdDeviz > 0">
                Retrimite Confirmare
                <span v-if="scope.row.IdDeviz > 0">(Are deviz)</span>
              </el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination @size-change="refresh_info" @current-change="refresh_info" :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page" :total="PaginationInfo.RowCount" layout="pager" />
    <Preview-email ref="dlg" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import Preview_email from './Preview_email.vue';
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "istoric_programari",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    'Preview-email': Preview_email,
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      Results: [],
      base_url: "",
      Info: {
      },
      Filters: {
        NumeClientUtilizator: "",
        TipEmail: "-1",
        Data: [],
        Status: "-1",
        IdRezervare: "",
        DataRezervarii: [],
      },
      OrderBy: { 'Id': 'DESC' },
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    async get_info() {
      // var response = await this.post("admin/istoric_programari/get_info");
      // this.Info.utilizatori = response.utilizatori;
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("admin/log_email/index_email", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("istoric_programari");
    },
    reset() {
      this.Filters = {
        NumeClientUtilizator: "",
        TipEmail: "-1",
        Data: [],
        Status: "-1",
        IdRezervare: "",
        DataRezervarii: [],
      };
      this.refresh_info();
    },
    handleActionCommand(command) {
      const { action, row } = command;

      switch (action) {
        case 'open_programare':
          this.$router.push({
            path: '/rezervari',
            query: { open_id: row.IdRezervare }
          });
          break;
        case 'view':
          this.preview(row.Id, row.NumeClient ? row.NumeClient : row.NumeUtilizator);
          break;
        case 'cancel':
          this.cancel_appointment(row);
          break;
        case 'correct_email':
          this.correct_email(row);
          break;
        case 'resend':
          this.resend_confirmation(row);
          break;
      }
    },

    cancel_appointment(row) {
      this.$prompt('Introdu motivul anularii pentru programarea #' + row.IdRezervare, 'Anuleaza Programare', {
        confirmButtonText: 'Anuleaza Programarea',
        cancelButtonText: 'Renunta',
        inputPattern: /.+/,
        inputErrorMessage: 'Motivul este obligatoriu'
      }).then(async ({ value }) => {
        let res = await this.post("receptie/rezervari/anuleaza", { id: row.IdRezervare, motiv: value});

        if (res.success) {
          this.$message({ type: 'success', message: 'Programare anulata cu succes!' });
          this.refresh_info();
        } else {
          this.$message({ type: 'error', message: res.error || 'Eroare la anulare' });
        }
      }).catch(() => {
      });
    },

    correct_email(row) {
      this.$prompt('Introdu noua adresa de email. Aceasta se va modifica la client si deviz (daca acesta exista).', 'Corecteaza Email', {
        confirmButtonText: 'Salveaza',
        cancelButtonText: 'Renunta',
        inputValue: row.Destinatar,
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: 'Email invalid'
      }).then(async ({ value }) => {
        if (value == row.Destinatar) {
          this.$message('Adresa de email este aceeasi.');
          return;
        }

        let res = await this.post("admin/log_email/correct_email_address", {
          IdRezervare: row.IdRezervare,
          IdClient: row.IdClient,
          IdLog: row.Id,
          NewEmail: value
        });

        if (res.Success) {
          this.$message({ type: 'success', message: res.Message });
          this.refresh_info();
        } else {
          this.$message({ type: 'error', message: res.Error || 'Eroare la actualizare' });
        }

      }).catch(() => { });
    },

    resend_confirmation(row) {
      const targetEmail = row.EmailClient ? row.EmailClient : row.Destinatar;

      let msg = `Se va trimite un email de confirmare catre <b>${targetEmail}</b>.`;

      if (row.EmailClient && row.EmailClient !== row.Destinatar) {
        msg += `<br><span style="font-size:12px; color: orange">
                  (Atentie: Adresa din istoric era ${row.Destinatar}, dar se trimite pe adresa actuala a clientului)
                  </span>`;
      }
      msg += `<br>Esti sigur?`;

      this.$confirm(msg, 'Retrimite Confirmare', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: 'Da, Trimite',
        cancelButtonText: 'Nu',
        type: 'warning'
      }).then(async () => {

        let res = await this.post('admin/log_email/resend_email', { Id: row.Id });

        if (res.Raspuns == 'Email retrimis cu succes.') {
          this.$message({ type: 'success', message: res.Raspuns });
          this.refresh_info();
        } else {
          this.$message({ type: 'error', message: 'Eroare la retrimitere.' });
        }
      }).catch(() => { });
    },

    preview(id, nume) {
      this.$refs.dlg.show_me(id, nume);
    },
  },
  mounted() {
    if (!this.$has_right('Management')) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  margin-right: 5%;
  width: 45%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}

.tabel-data {
  word-break: keep-all;

}
</style>
